import { Button, ButtonProps, Tooltip } from "antd";
import { RiFullscreenExitFill, RiFullscreenFill } from "react-icons/ri";
import useFullScreen from "src/hook/useFullScreen";
import './XmFullScreenButton.less';

export const XmFullScreenButton = ({ className, ...props }: ButtonProps) => {
  const { isFullScreen, toggle } = useFullScreen();

  return (
    <Tooltip mouseLeaveDelay={0} mouseEnterDelay={0.2} title={<div>{isFullScreen ? 'Show left and top menu.' : 'Hide left and top menu.'}<br />Use F11 to switch browser fullscreen mode.</div>}>
      <Button
        className={[FULL_SCREEN_BTN_CLS, isFullScreen && FULL_SCREEN_ON_CLS, className].filter(Boolean).join(' ')}
        aria-pressed={isFullScreen}
        aria-label={isFullScreen ? 'Exit full screen' : 'Full screen'}
        icon={isFullScreen ? <RiFullscreenExitFill /> : <RiFullscreenFill />}
        {...props}
        onClick={toggle}
      />
    </Tooltip>
  );
};

const FULL_SCREEN_BTN_CLS = 'xm-full-screen-btn' as const;
const FULL_SCREEN_ON_CLS = 'xm-full-screen-btn-on' as const;

export default XmFullScreenButton;
